import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { User } from 'Interfaces/User';
import { selectUser } from 'Utils/selectors';

import AppSumoActiveScreen from '../AppSumoActiveScreen';
import BillingDefaultPlanScreen from '../BillingDefaultPlanScreen';
import { BillingPageAction } from '../BillingDefaultPlanScreen/planTableItems';

interface PageParameters {
  action?: BillingPageAction;
}

const BillingPlan = () => {
  const locationState = useLocation().state as PageParameters;
  const { appSumoStatus }: User = useSelector(selectUser);

  if (appSumoStatus) {
    return <AppSumoActiveScreen />;
  }

  return <BillingDefaultPlanScreen pageAction={locationState?.action} />;
};

export default BillingPlan;
